// 스크롤바 너비 계산
export const getScrollbarWidth = () => {
  // 이미 계산된 값이 있으면 재사용
  if (typeof window !== 'undefined' && window.__scrollbarWidth !== undefined) {
    return window.__scrollbarWidth;
  }

  // 스크롤바 너비 계산
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.msOverflowStyle = 'scrollbar';
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);

  // 계산된 값 저장
  if (typeof window !== 'undefined') {
    window.__scrollbarWidth = scrollbarWidth;
  }

  return scrollbarWidth;
};

// 스크롤 잠금
export const lockScroll = () => {
  // 이미 lock된 상태면 실행하지 않음
  if (document.body.dataset.scrollY) {
    console.warn('Scroll already locked');
    return;
  }
  
  const scrollY = window.pageYOffset || document.documentElement.scrollTop;
  
  // 기존 overflow 값 저장
  const originalOverflow = document.body.style.overflow;
  const originalTouchAction = document.body.style.touchAction;
  const originalPosition = document.body.style.position;
  
  // 스크롤 방지 - position fixed로 완전히 고정
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.width = '100%';
  document.body.style.overflow = 'hidden';
  document.body.style.touchAction = 'none';
  
  // 모바일이 아닌 경우에만 스크롤바 너비만큼 padding 추가
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
  let originalPaddingRight = '';
  
  if (!isMobile) {
    const scrollbarWidth = getScrollbarWidth();
    originalPaddingRight = document.body.style.paddingRight;
    if (scrollbarWidth > 0) {
      const currentPadding = parseInt(window.getComputedStyle(document.body).paddingRight, 10) || 0;
      document.body.style.paddingRight = `${currentPadding + scrollbarWidth}px`;
      
      // scale-wrapper에도 동일한 padding 적용
      const scaleWrapper = document.querySelector('.scale-wrapper');
      if (scaleWrapper) {
        const originalScalePadding = scaleWrapper.style.paddingRight;
        const currentScalePadding = parseInt(window.getComputedStyle(scaleWrapper).paddingRight, 10) || 0;
        scaleWrapper.style.paddingRight = `${currentScalePadding + scrollbarWidth}px`;
        scaleWrapper.dataset.originalPaddingRight = originalScalePadding || '';
      }
    }
  }
  
  // 원래 값들을 dataset에 저장
  document.body.dataset.scrollY = scrollY;
  document.body.dataset.originalOverflow = originalOverflow || '';
  document.body.dataset.originalTouchAction = originalTouchAction || '';
  document.body.dataset.originalPosition = originalPosition || '';
  document.body.dataset.originalTop = document.body.style.top || '';
  document.body.dataset.originalWidth = document.body.style.width || '';
  
  // 모바일이 아닌 경우에만 padding 관련 값 저장
  if (!isMobile) {
    document.body.dataset.originalPaddingRight = originalPaddingRight || '';
  }
};

// 스크롤 잠금 해제
export const unlockScroll = () => {
  // 이미 unlock된 상태면 실행하지 않음
  if (!document.body.dataset.scrollY) {
    return;
  }
  
  // 저장된 값들 가져오기
  const scrollY = parseInt(document.body.dataset.scrollY || '0');
  const originalOverflow = document.body.dataset.originalOverflow || '';
  const originalTouchAction = document.body.dataset.originalTouchAction || '';
  const originalPaddingRight = document.body.dataset.originalPaddingRight || '';
  const originalPosition = document.body.dataset.originalPosition || '';
  const originalTop = document.body.dataset.originalTop || '';
  const originalWidth = document.body.dataset.originalWidth || '';
  
  // dataset 정리 (먼저 실행하여 중복 호출 방지)
  delete document.body.dataset.scrollY;
  delete document.body.dataset.originalOverflow;
  delete document.body.dataset.originalTouchAction;
  delete document.body.dataset.originalPaddingRight;
  delete document.body.dataset.originalPosition;
  delete document.body.dataset.originalTop;
  delete document.body.dataset.originalWidth;
  
  // 스타일 복원
  document.body.style.position = originalPosition;
  document.body.style.top = originalTop;
  document.body.style.width = originalWidth;
  document.body.style.overflow = originalOverflow;
  document.body.style.touchAction = originalTouchAction;
  document.body.style.paddingRight = originalPaddingRight;
  
  // scale-wrapper 스타일도 복원
  const scaleWrapper = document.querySelector('.scale-wrapper');
  if (scaleWrapper && scaleWrapper.dataset.originalPaddingRight !== undefined) {
    scaleWrapper.style.paddingRight = scaleWrapper.dataset.originalPaddingRight;
    delete scaleWrapper.dataset.originalPaddingRight;
  }
  
  // 스크롤 위치 복원
  if (scrollY >= 0) {
    window.scrollTo(0, scrollY);
  }
};